export type MusicRegistrationCompletionStatus =
  | 'tutor-submitted'
  | 'parent-submitted'
  | 'tutor-approved'
  | 'tutor-pending'
  | 'session-unavailable';

export const getMusicRegistrationCompletionPath = (
  status: MusicRegistrationCompletionStatus,
) => `/music-register/completion?status=${status}`;
